import * as Yup from "yup";

const validation = Yup.object({
  selectedProductUuid: Yup.string().required("Please select a product"),
}).nullable();

export default validation;
